<template>
  <button
    :class="
      isSelected
        ? 'centers-region-button neumorphism-in'
        : 'centers-region-button neumorphism-out'
    "
    @click="onClick(region)"
    @mouseover="onMouseOver(region)"
    @mouseleave="onMouseLeave(region)"
  >
    <span class="text-body-2">{{ region.title }}</span>
  </button>
</template>

<script>
export default {
  name: "RegionButton",
  props: {
    region: null,
    isSelected: false,
  },
  methods: {
    /**
     * Notifies the parent component that a click occurred on this button
     * and transmits its associated region
     */
    onClick(region) {
      this.$emit("click", region);
    },
    onMouseOver(region) {
      this.$emit("mouseover", region);
    },
    onMouseLeave(region) {
      this.$emit("mouseleave", region);
    },
  },
};
</script>

<style lang="scss" scoped>
.centers-region-button {
  user-select: none;
  border-radius: 50px;
  padding: 7px 10px;
  justify-items: center;
  margin: 5px 0 0 5px;
}
</style>
